import "./Microwave.css"
import Product1 from "./Product1"
import Alexa from "../images/alexa.jpg"
import Mw1 from "../images/mw1.jpg"
import Mw2 from "../images/mw2.jpg"
import Mw3 from "../images/mw3.jpg"
import Mw4 from "../images/mw4.jpg"
import Mw5 from "../images/mw5.jpg"
import Mw6 from "../images/mw6.jpg"
import Mw7 from "../images/mw7.jpg"
import Mw8 from "../images/mw8.jpg"
import Mw9 from "../images/microwaveadd.png"


export default function Microwave() {

  return (
    <div className="stdivinhome">
       <div className="add"><img src={Mw9} /></div>
          
                   

      <div className="home">

        <div className="home__prd">

          <div className="home__prd1">

            <Product1  id="mw1" prdName="LG" img={Mw1} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
              <Product1  id="mw2"prdName="HAIER" img={Mw2} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>          

          </div>

          <div className="home__prd1">

          
          <Product1 id="mw3"prdName="BLUESTAR" img={Mw3} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="mw4"prdName="SAMSUNG" img={Mw4} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
        

          </div>

        </div>


        <div className="home__prd">

          <div className="home__prd1">

            <Product1 id="mw5"prdName="ONIDA" img={Mw5} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1 id="mw6"prdName="HAIER3" img={Mw6} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1 id="mw7"prdName="BLUSTAR" img={Mw7} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="mw8"prdName="WHIRLPOOL" img={Mw8} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>

      </div>

    </div>
  )
}